<template>
  <div class="infobox" :style="{
    width: `${width}px`
  }"
  ref="box">
  <div class="headerBox">
    <div class="icon" :style="{backgroundImage: `url(./svg/slide/${icon}.svg)`}"></div>
    <div v-html="label" class="label"></div>
    <slot name="header"></slot>
    <button class="closeBtn" @click="$emit('close')"><iconClose :width="30" :height="30" color="#FFFFFF" backgroundColor="none"/></button>
    <button class="printBtn" v-show="printBtn" @click="$emit('printInfo')">{{btnText ? btnText : '列印'}}</button>
  </div>
  <slot/>
  </div>
</template>

<script>
import iconClose from '../SVG/iconClose'
export default {
  name: 'infobox',
  props: ['show', 'width', 'label', 'printBtn', 'btnText', 'defaultClass', 'icon'],
  components: {
    iconClose
  },
  created () {
    this.$nextTick(() => {
      if (this.show) {
        this.$refs.box.classList.add(this.defaultClass)
      }
    })
  },
  watch: {
    show () {
      if (this.show) {
        this.$refs.box.classList.remove('slide-out')
        this.$refs.box.classList.add('slide-in')
      } else {
        this.$refs.box.classList.remove('slide-in')
        this.$refs.box.classList.add('slide-out')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.label {
  text-align: start;
}
.icon {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  border: 3px solid #FFFFFF;
  background-position: center;
  background-repeat: no-repeat;
}
.infobox {
  background-color: #FFFFFF;
}
.headerBox {
  width: 100%;
  height: 95px;
  background-color: var(--color-pri);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;

  color: #FFFFFF;
  gap: 14px;
}
.closeBtn {
  position: absolute;
  top: 13px;
  right: 17px;
  background-color: transparent;
  border: none;
  z-index: 91;
  width: 30px;
  height: 31px;
}
.printBtn {
  position: absolute;
  top: 53px;
  right: 17px;
  border: none;
  z-index: 91;
  width: 60px;
  height: 30px;
  background-color: var(--color-pri-letter);
  color: var(--color-pri);
  border-radius: 15px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
}
.infobox {
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: 100vh!important;
  min-width: 481px;
  position: var(--dialogPosition);
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #FFFFFF;
  z-index: 91;
  transform: translateX(100%);
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 95px 1fr;
}

.slide-in {
    animation: slide-in 0.5s forwards;
    -webkit-animation: slide-in 0.5s forwards;
}

.slide-out {
    animation: slide-out 0.5s forwards;
    -webkit-animation: slide-out 0.5s forwards;
}

@keyframes slide-in {
    100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in {
    100% { -webkit-transform: translateX(0%); }
}

@keyframes slide-out {
    0% { transform: translateX(0%); }
    100% { transform: translateX(calc(100% + 15px));  }
}

@-webkit-keyframes slide-out {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(calc(100% + 15px)); }
}
</style>
